import * as Preact from 'preact';
import * as Hooks from 'preact/hooks';
import { TranslateProvider, TranslateContext } from '@denysvuika/preact-translate';

export const TranslationsWrapper = (props: { children: Preact.ComponentChildren }) => {

    return (
        <TranslateProvider root='assets/locales' lang='en-GB' fallbackLang='en-GB'>
            { props.children }
        </TranslateProvider>
    );
};

export const useTranslations = () => {
    const context = Hooks.useContext(TranslateContext);

    if (context === undefined) {
        throw new Error('useTranslations must be used within a TranslationsWrapper!');
    };

    return context;
};